module.exports = __webpack_public_path__ + "img/skull_20_bj.b7b72d12.png";